export default {
  'sidebar.projects': 'Projects',
  'sidebar.projects.cohorts': 'Cohorts',
  'sidebar.projects.data-reliability': 'Data reliability',
  'sidebar.users': 'Users',
  'sidebar.organizations': 'Organizations',
  'sidebar.data-administration': 'Dataset delivery',
  'sidebar.data-administration.dataset-delivery': 'Dataset delivery',
  'sidebar.dataset-delivery': 'Dataset delivery',
  'sidebar.data-administration.data-intake': 'Data intake',
  'sidebar.sectionTitle.projects': 'Cohort Management',
  'sidebar.sectionTitle.dataAdmin': 'Data Administration',
  'sidebar.sectionTitle.sysAdmin': 'System Administration',
  'sidebar.extraction-accuracy': 'Results',
  'sidebar.sectionTitle.extractionAccuracy': 'Extraction Accuracy',
  'sidebar.concept-groups': 'Concept Groups',
};
